// #region Imports
import { defineComponent } from 'vue';
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-search-box__table',
    // #endregion
    // #region Props
    props: {
        items: {
            type: Array,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        iconField: {
            type: String,
            default: null,
        },
        selectedItem: {
            type: Object,
            default: null,
        },
        idField: {
            type: String,
            default: 'id',
        },
        highlightedIndex: {
            type: Number,
            default: -1,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isLoadingMore: {
            type: Boolean,
            default: false,
        },
    },
    // #endregion
    emits: {
        select: (_item) => true,
    },
    // #region Computed
    computed: {
        colCount() {
            return (this.iconField ? 1 : 0) + this.columns.length;
        },
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Helper
        isSelected(item) {
            return !!this.selectedItem && this.selectedItem[this.idField] === item[this.idField];
        },
        // #endregion
    },
    // #endregion
});
// #endregion
